import { makeStyles } from 'tss-react/mui';

const useStylesModalLayout: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  modalLayout: {
    padding: 20,
    width: '100%',
    maxWidth: '50% !important',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(400px + 10%) !important',
    },
  },
  modalLayoutMedium: {
    maxWidth: '70% !important',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(600px + 10%) !important',
    },
  },
  modalLayoutLarge: {
    maxWidth: '85% !important',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(600px + 10%) !important',
    },
  },
  modalLayoutSubModal: {
    maxWidth: '40% !important',
    [theme.breakpoints.down('md')]: {
      maxWidth: '50% !important',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '80% !important',
    },
  },
}));

export default useStylesModalLayout;
